const raw = {
    "AC": {"name": "Ascension Island", "emoji": "🇦🇨",},
    "AD": {"name": "Andorra", "emoji": "🇦🇩",},
    "AE": {"name": "United Arab Emirates", "emoji": "🇦🇪",},
    "AF": {"name": "Afghanistan", "emoji": "🇦🇫",},
    "AG": {"name": "Antigua & Barbuda", "emoji": "🇦🇬",},
    "AI": {"name": "Anguilla", "emoji": "🇦🇮",},
    "AL": {"name": "Albania", "emoji": "🇦🇱",},
    "AM": {"name": "Armenia", "emoji": "🇦🇲",},
    "AO": {"name": "Angola", "emoji": "🇦🇴",},
    "AQ": {"name": "Antarctica", "emoji": "🇦🇶",},
    "AR": {"name": "Argentina", "emoji": "🇦🇷",},
    "AS": {"name": "American Samoa", "emoji": "🇦🇸",},
    "AT": {"name": "Austria", "emoji": "🇦🇹",},
    "AU": {"name": "Australia", "emoji": "🇦🇺",},
    "AW": {"name": "Aruba", "emoji": "🇦🇼",},
    "AX": {"name": "Åland Islands", "emoji": "🇦🇽",},
    "AZ": {"name": "Azerbaijan", "emoji": "🇦🇿",},
    "BA": {"name": "Bosnia & Herzegovina", "emoji": "🇧🇦",},
    "BB": {"name": "Barbados", "emoji": "🇧🇧",},
    "BD": {"name": "Bangladesh", "emoji": "🇧🇩",},
    "BE": {"name": "Belgium", "emoji": "🇧🇪",},
    "BF": {"name": "Burkina Faso", "emoji": "🇧🇫",},
    "BG": {"name": "Bulgaria", "emoji": "🇧🇬",},
    "BH": {"name": "Bahrain", "emoji": "🇧🇭",},
    "BI": {"name": "Burundi", "emoji": "🇧🇮",},
    "BJ": {"name": "Benin", "emoji": "🇧🇯",},
    "BL": {"name": "St. Barthélemy", "emoji": "🇧🇱",},
    "BM": {"name": "Bermuda", "emoji": "🇧🇲",},
    "BN": {"name": "Brunei", "emoji": "🇧🇳",},
    "BO": {"name": "Bolivia", "emoji": "🇧🇴",},
    "BQ": {"name": "Caribbean Netherlands", "emoji": "🇧🇶",},
    "BR": {"name": "Brazil", "emoji": "🇧🇷",},
    "BS": {"name": "Bahamas", "emoji": "🇧🇸",},
    "BT": {"name": "Bhutan", "emoji": "🇧🇹",},
    "BV": {"name": "Bouvet Island", "emoji": "🇧🇻",},
    "BW": {"name": "Botswana", "emoji": "🇧🇼",},
    "BY": {"name": "Belarus", "emoji": "🇧🇾",},
    "BZ": {"name": "Belize", "emoji": "🇧🇿",},
    "CA": {"name": "Canada", "emoji": "🇨🇦",},
    "CC": {"name": "Cocos (Keeling) Islands", "emoji": "🇨🇨",},
    "CD": {"name": "Congo - Kinshasa", "emoji": "🇨🇩",},
    "CF": {"name": "Central African Republic", "emoji": "🇨🇫",},
    "CG": {"name": "Congo - Brazzaville", "emoji": "🇨🇬",},
    "CH": {"name": "Switzerland", "emoji": "🇨🇭",},
    "CI": {"name": "Côte d’Ivoire", "emoji": "🇨🇮",},
    "CK": {"name": "Cook Islands", "emoji": "🇨🇰",},
    "CL": {"name": "Chile", "emoji": "🇨🇱",},
    "CM": {"name": "Cameroon", "emoji": "🇨🇲",},
    "CN": {"name": "China", "emoji": "🇨🇳",},
    "CO": {"name": "Colombia", "emoji": "🇨🇴",},
    "CP": {"name": "Clipperton Island", "emoji": "🇨🇵",},
    "CR": {"name": "Costa Rica", "emoji": "🇨🇷",},
    "CU": {"name": "Cuba", "emoji": "🇨🇺",},
    "CV": {"name": "Cape Verde", "emoji": "🇨🇻",},
    "CW": {"name": "Curaçao", "emoji": "🇨🇼",},
    "CX": {"name": "Christmas Island", "emoji": "🇨🇽",},
    "CY": {"name": "Cyprus", "emoji": "🇨🇾",},
    "CZ": {"name": "Czechia", "emoji": "🇨🇿",},
    "DE": {"name": "Germany", "emoji": "🇩🇪",},
    "DG": {"name": "Diego Garcia", "emoji": "🇩🇬",},
    "DJ": {"name": "Djibouti", "emoji": "🇩🇯",},
    "DK": {"name": "Denmark", "emoji": "🇩🇰",},
    "DM": {"name": "Dominica", "emoji": "🇩🇲",},
    "DO": {"name": "Dominican Republic", "emoji": "🇩🇴",},
    "DZ": {"name": "Algeria", "emoji": "🇩🇿",},
    "EA": {"name": "Ceuta & Melilla", "emoji": "🇪🇦",},
    "EC": {"name": "Ecuador", "emoji": "🇪🇨",},
    "EE": {"name": "Estonia", "emoji": "🇪🇪",},
    "EG": {"name": "Egypt", "emoji": "🇪🇬",},
    "EH": {"name": "Western Sahara", "emoji": "🇪🇭",},
    "ER": {"name": "Eritrea", "emoji": "🇪🇷",},
    "ES": {"name": "Spain", "emoji": "🇪🇸",},
    "ET": {"name": "Ethiopia", "emoji": "🇪🇹",},
    "EU": {"name": "European Union", "emoji": "🇪🇺",},
    "FI": {"name": "Finland", "emoji": "🇫🇮",},
    "FJ": {"name": "Fiji", "emoji": "🇫🇯",},
    "FK": {"name": "Falkland Islands", "emoji": "🇫🇰",},
    "FM": {"name": "Micronesia", "emoji": "🇫🇲",},
    "FO": {"name": "Faroe Islands", "emoji": "🇫🇴",},
    "FR": {"name": "France", "emoji": "🇫🇷",},
    "GA": {"name": "Gabon", "emoji": "🇬🇦",},
    "GB": {"name": "United Kingdom", "emoji": "🇬🇧",},
    "GD": {"name": "Grenada", "emoji": "🇬🇩",},
    "GE": {"name": "Georgia", "emoji": "🇬🇪",},
    "GF": {"name": "French Guiana", "emoji": "🇬🇫",},
    "GG": {"name": "Guernsey", "emoji": "🇬🇬",},
    "GH": {"name": "Ghana", "emoji": "🇬🇭",},
    "GI": {"name": "Gibraltar", "emoji": "🇬🇮",},
    "GL": {"name": "Greenland", "emoji": "🇬🇱",},
    "GM": {"name": "Gambia", "emoji": "🇬🇲",},
    "GN": {"name": "Guinea", "emoji": "🇬🇳",},
    "GP": {"name": "Guadeloupe", "emoji": "🇬🇵",},
    "GQ": {"name": "Equatorial Guinea", "emoji": "🇬🇶",},
    "GR": {"name": "Greece", "emoji": "🇬🇷",},
    "GS": {"name": "South Georgia & South Sandwich Islands", "emoji": "🇬🇸",},
    "GT": {"name": "Guatemala", "emoji": "🇬🇹",},
    "GU": {"name": "Guam", "emoji": "🇬🇺",},
    "GW": {"name": "Guinea-Bissau", "emoji": "🇬🇼",},
    "GY": {"name": "Guyana", "emoji": "🇬🇾",},
    "HK": {"name": "Hong Kong SAR China", "emoji": "🇭🇰",},
    "HM": {"name": "Heard & McDonald Islands", "emoji": "🇭🇲",},
    "HN": {"name": "Honduras", "emoji": "🇭🇳",},
    "HR": {"name": "Croatia", "emoji": "🇭🇷",},
    "HT": {"name": "Haiti", "emoji": "🇭🇹",},
    "HU": {"name": "Hungary", "emoji": "🇭🇺",},
    "IC": {"name": "Canary Islands", "emoji": "🇮🇨",},
    "ID": {"name": "Indonesia", "emoji": "🇮🇩",},
    "IE": {"name": "Ireland", "emoji": "🇮🇪",},
    "IL": {"name": "Israel", "emoji": "🇮🇱",},
    "IM": {"name": "Isle of Man", "emoji": "🇮🇲",},
    "IN": {"name": "India", "emoji": "🇮🇳",},
    "IO": {"name": "British Indian Ocean Territory", "emoji": "🇮🇴",},
    "IQ": {"name": "Iraq", "emoji": "🇮🇶",},
    "IR": {"name": "Iran", "emoji": "🇮🇷",},
    "IS": {"name": "Iceland", "emoji": "🇮🇸",},
    "IT": {"name": "Italy", "emoji": "🇮🇹",},
    "JE": {"name": "Jersey", "emoji": "🇯🇪",},
    "JM": {"name": "Jamaica", "emoji": "🇯🇲",},
    "JO": {"name": "Jordan", "emoji": "🇯🇴",},
    "JP": {"name": "Japan", "emoji": "🇯🇵",},
    "KE": {"name": "Kenya", "emoji": "🇰🇪",},
    "KG": {"name": "Kyrgyzstan", "emoji": "🇰🇬",},
    "KH": {"name": "Cambodia", "emoji": "🇰🇭",},
    "KI": {"name": "Kiribati", "emoji": "🇰🇮",},
    "KM": {"name": "Comoros", "emoji": "🇰🇲",},
    "KN": {"name": "St. Kitts & Nevis", "emoji": "🇰🇳",},
    "KP": {"name": "North Korea", "emoji": "🇰🇵",},
    "KR": {"name": "South Korea", "emoji": "🇰🇷",},
    "KW": {"name": "Kuwait", "emoji": "🇰🇼",},
    "KY": {"name": "Cayman Islands", "emoji": "🇰🇾",},
    "KZ": {"name": "Kazakhstan", "emoji": "🇰🇿",},
    "LA": {"name": "Laos", "emoji": "🇱🇦",},
    "LB": {"name": "Lebanon", "emoji": "🇱🇧",},
    "LC": {"name": "St. Lucia", "emoji": "🇱🇨",},
    "LI": {"name": "Liechtenstein", "emoji": "🇱🇮",},
    "LK": {"name": "Sri Lanka", "emoji": "🇱🇰",},
    "LR": {"name": "Liberia", "emoji": "🇱🇷",},
    "LS": {"name": "Lesotho", "emoji": "🇱🇸",},
    "LT": {"name": "Lithuania", "emoji": "🇱🇹",},
    "LU": {"name": "Luxembourg", "emoji": "🇱🇺",},
    "LV": {"name": "Latvia", "emoji": "🇱🇻",},
    "LY": {"name": "Libya", "emoji": "🇱🇾",},
    "MA": {"name": "Morocco", "emoji": "🇲🇦",},
    "MC": {"name": "Monaco", "emoji": "🇲🇨",},
    "MD": {"name": "Moldova", "emoji": "🇲🇩",},
    "ME": {"name": "Montenegro", "emoji": "🇲🇪",},
    "MF": {"name": "St. Martin", "emoji": "🇲🇫",},
    "MG": {"name": "Madagascar", "emoji": "🇲🇬",},
    "MH": {"name": "Marshall Islands", "emoji": "🇲🇭",},
    "MK": {"name": "North Macedonia", "emoji": "🇲🇰",},
    "ML": {"name": "Mali", "emoji": "🇲🇱",},
    "MM": {"name": "Myanmar (Burma)", "emoji": "🇲🇲",},
    "MN": {"name": "Mongolia", "emoji": "🇲🇳",},
    "MO": {"name": "Macao SAR China", "emoji": "🇲🇴",},
    "MP": {"name": "Northern Mariana Islands", "emoji": "🇲🇵",},
    "MQ": {"name": "Martinique", "emoji": "🇲🇶",},
    "MR": {"name": "Mauritania", "emoji": "🇲🇷",},
    "MS": {"name": "Montserrat", "emoji": "🇲🇸",},
    "MT": {"name": "Malta", "emoji": "🇲🇹",},
    "MU": {"name": "Mauritius", "emoji": "🇲🇺",},
    "MV": {"name": "Maldives", "emoji": "🇲🇻",},
    "MW": {"name": "Malawi", "emoji": "🇲🇼",},
    "MX": {"name": "Mexico", "emoji": "🇲🇽",},
    "MY": {"name": "Malaysia", "emoji": "🇲🇾",},
    "MZ": {"name": "Mozambique", "emoji": "🇲🇿",},
    "NA": {"name": "Namibia", "emoji": "🇳🇦",},
    "NC": {"name": "New Caledonia", "emoji": "🇳🇨",},
    "NE": {"name": "Niger", "emoji": "🇳🇪",},
    "NF": {"name": "Norfolk Island", "emoji": "🇳🇫",},
    "NG": {"name": "Nigeria", "emoji": "🇳🇬",},
    "NI": {"name": "Nicaragua", "emoji": "🇳🇮",},
    "NL": {"name": "Netherlands", "emoji": "🇳🇱",},
    "NO": {"name": "Norway", "emoji": "🇳🇴",},
    "NP": {"name": "Nepal", "emoji": "🇳🇵",},
    "NR": {"name": "Nauru", "emoji": "🇳🇷",},
    "NU": {"name": "Niue", "emoji": "🇳🇺",},
    "NZ": {"name": "New Zealand", "emoji": "🇳🇿",},
    "OM": {"name": "Oman", "emoji": "🇴🇲",},
    "PA": {"name": "Panama", "emoji": "🇵🇦",},
    "PE": {"name": "Peru", "emoji": "🇵🇪",},
    "PF": {"name": "French Polynesia", "emoji": "🇵🇫",},
    "PG": {"name": "Papua New Guinea", "emoji": "🇵🇬",},
    "PH": {"name": "Philippines", "emoji": "🇵🇭",},
    "PK": {"name": "Pakistan", "emoji": "🇵🇰",},
    "PL": {"name": "Poland", "emoji": "🇵🇱",},
    "PM": {"name": "St. Pierre & Miquelon", "emoji": "🇵🇲",},
    "PN": {"name": "Pitcairn Islands", "emoji": "🇵🇳",},
    "PR": {"name": "Puerto Rico", "emoji": "🇵🇷",},
    "PS": {"name": "Palestinian Territories", "emoji": "🇵🇸",},
    "PT": {"name": "Portugal", "emoji": "🇵🇹",},
    "PW": {"name": "Palau", "emoji": "🇵🇼",},
    "PY": {"name": "Paraguay", "emoji": "🇵🇾",},
    "QA": {"name": "Qatar", "emoji": "🇶🇦",},
    "RE": {"name": "Réunion", "emoji": "🇷🇪",},
    "RO": {"name": "Romania", "emoji": "🇷🇴",},
    "RS": {"name": "Serbia", "emoji": "🇷🇸",},
    "RU": {"name": "Russia", "emoji": "🇷🇺",},
    "RW": {"name": "Rwanda", "emoji": "🇷🇼",},
    "SA": {"name": "Saudi Arabia", "emoji": "🇸🇦",},
    "SB": {"name": "Solomon Islands", "emoji": "🇸🇧",},
    "SC": {"name": "Seychelles", "emoji": "🇸🇨",},
    "SD": {"name": "Sudan", "emoji": "🇸🇩",},
    "SE": {"name": "Sweden", "emoji": "🇸🇪",},
    "SG": {"name": "Singapore", "emoji": "🇸🇬",},
    "SH": {"name": "St. Helena", "emoji": "🇸🇭",},
    "SI": {"name": "Slovenia", "emoji": "🇸🇮",},
    "SJ": {"name": "Svalbard & Jan Mayen", "emoji": "🇸🇯",},
    "SK": {"name": "Slovakia", "emoji": "🇸🇰",},
    "SL": {"name": "Sierra Leone", "emoji": "🇸🇱",},
    "SM": {"name": "San Marino", "emoji": "🇸🇲",},
    "SN": {"name": "Senegal", "emoji": "🇸🇳",},
    "SO": {"name": "Somalia", "emoji": "🇸🇴",},
    "SR": {"name": "Suriname", "emoji": "🇸🇷",},
    "SS": {"name": "South Sudan", "emoji": "🇸🇸",},
    "ST": {"name": "São Tomé & Príncipe", "emoji": "🇸🇹",},
    "SV": {"name": "El Salvador", "emoji": "🇸🇻",},
    "SX": {"name": "Sint Maarten", "emoji": "🇸🇽",},
    "SY": {"name": "Syria", "emoji": "🇸🇾",},
    "SZ": {"name": "Eswatini", "emoji": "🇸🇿",},
    "TA": {"name": "Tristan da Cunha", "emoji": "🇹🇦",},
    "TC": {"name": "Turks & Caicos Islands", "emoji": "🇹🇨",},
    "TD": {"name": "Chad", "emoji": "🇹🇩",},
    "TF": {"name": "French Southern Territories", "emoji": "🇹🇫",},
    "TG": {"name": "Togo", "emoji": "🇹🇬",},
    "TH": {"name": "Thailand", "emoji": "🇹🇭",},
    "TJ": {"name": "Tajikistan", "emoji": "🇹🇯",},
    "TK": {"name": "Tokelau", "emoji": "🇹🇰",},
    "TL": {"name": "Timor-Leste", "emoji": "🇹🇱",},
    "TM": {"name": "Turkmenistan", "emoji": "🇹🇲",},
    "TN": {"name": "Tunisia", "emoji": "🇹🇳",},
    "TO": {"name": "Tonga", "emoji": "🇹🇴",},
    "TR": {"name": "Turkey", "emoji": "🇹🇷",},
    "TT": {"name": "Trinidad & Tobago", "emoji": "🇹🇹",},
    "TV": {"name": "Tuvalu", "emoji": "🇹🇻",},
    "TW": {"name": "Taiwan", "emoji": "🇹🇼",},
    "TZ": {"name": "Tanzania", "emoji": "🇹🇿",},
    "UA": {"name": "Ukraine", "emoji": "🇺🇦",},
    "UG": {"name": "Uganda", "emoji": "🇺🇬",},
    "UM": {"name": "U.S. Outlying Islands", "emoji": "🇺🇲",},
    "UN": {"name": "United Nations", "emoji": "🇺🇳",},
    "US": {"name": "United States", "emoji": "🇺🇸",},
    "UY": {"name": "Uruguay", "emoji": "🇺🇾",},
    "UZ": {"name": "Uzbekistan", "emoji": "🇺🇿",},
    "VA": {"name": "Vatican City", "emoji": "🇻🇦",},
    "VC": {"name": "St. Vincent & Grenadines", "emoji": "🇻🇨",},
    "VE": {"name": "Venezuela", "emoji": "🇻🇪",},
    "VG": {"name": "British Virgin Islands", "emoji": "🇻🇬",},
    "VI": {"name": "U.S. Virgin Islands", "emoji": "🇻🇮",},
    "VN": {"name": "Vietnam", "emoji": "🇻🇳",},
    "VU": {"name": "Vanuatu", "emoji": "🇻🇺",},
    "WF": {"name": "Wallis & Futuna", "emoji": "🇼🇫",},
    "WS": {"name": "Samoa", "emoji": "🇼🇸",},
    "XK": {"name": "Kosovo", "emoji": "🇽🇰",},
    "YE": {"name": "Yemen", "emoji": "🇾🇪",},
    "YT": {"name": "Mayotte", "emoji": "🇾🇹",},
    "ZA": {"name": "South Africa", "emoji": "🇿🇦",},
    "ZM": {"name": "Zambia", "emoji": "🇿🇲",},
    "ZW": {"name": "Zimbabwe", "emoji": "🇿🇼",},
    "ENGLAND": {"name": "England", "emoji": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",},
    "SCOTLAND": {"name": "Scotland", "emoji": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",},
    "WALES": {"name": "Wales", "emoji": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",}
};

export default function FlagByCountryCode(code) {
    let upper = code.toUpperCase();
    return raw[upper] ? raw[upper] && raw[upper].emoji : "";
}